/* eslint-disable */
export default {
  _FuzzTastic: 'FuzzTastic',
  _Logo_Fuzz_Bugs: 'Logo_Fuzz_Bugs',
}